export default {
    legacyFix: true,
};
